import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Box } from '@maui/elements'

export const CheckboxGroup = ({ value = [], onChange, items, inputProps, ...props }) => {
  const handleChange = (e) => {
    const { value: itemValue, checked } = e.target
    const newValue = checked
      ? [...value, itemValue]
      : value.filter(v => v !== itemValue)
    onChange(newValue)
  }

  return (
    <Box {...props}>
      {
        items.map((item, index) => (
          <Checkbox
            key={index}
            value={item.value}
            checked={value && value.includes(item.value)}
            onChange={handleChange}
            disabled={Object.hasOwn(item, 'access') && !item.access}
            {...inputProps}
          >
            { item.label }
          </Checkbox>
        ))
      }
    </Box>
  )
}

CheckboxGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
  inputProps: PropTypes.object,
}
